

export const baseURL= 
  "https://admin.houseofdhanushdhari.com/api/" 
 


export const auth={
   login: baseURL+"developer/login",
   register:baseURL+'developer/register',
   getProfile:baseURL+'developer/profile',
   logoutUser:baseURL+'developer/logout'
}



export const property={
   getProperty:baseURL+'developers-property',
   getGallery:baseURL+'developers-gallery',
   sendEnquiry:baseURL+'real-estate-property-enquiry',
   orderProperty:baseURL+'developer/property/create-order',
   verifyPayment:baseURL+'developer/property/verify-payment'
}

